export class LegendEntry {
    name: string;
    color: string;
    fontColor: string;

    constructor(le: LegendEntry) {
        this.name = le.name;
        this.color = le.color;
        this.fontColor = le.fontColor;
    }
}

export class Station {

    id: number;
    xCoordinate: number;
    yCoordinate: number;
    statusStyleClasses: string;
    identifier: string;
    isWorkingArea: boolean;
    isWaitingArea: boolean;
    subTitle: string;
    capacity: number;
    usage: number;
    transportId: number;
    transportStatusStyle: string;
    color: string;
    fontColor: string;

    calculatedStyle: any;

    constructor(station: Station) {
        this.id = station.id;
        this.xCoordinate = station.xCoordinate;
        this.yCoordinate = station.yCoordinate;
        this.statusStyleClasses = station.statusStyleClasses;
        this.identifier = station.identifier;
        this.isWorkingArea = station.isWorkingArea;
        this.isWaitingArea = station.isWaitingArea;
        this.subTitle = station.subTitle;
        this.capacity = station.capacity;
        this.usage = station.usage;
        this.transportId = station.transportId;
        this.transportStatusStyle = station.transportStatusStyle;
        this.color = station.color;
        this.fontColor = station.fontColor;
    }
}


export class YardMap {

    name: string;
    mapResourceUUID: string;
    width: number;
    height: number;
    legendPosition: string;

    legendEntries = new Array<LegendEntry>();
    stations = new Array<Station>();

    constructor(map?: YardMap) {
        if (map != null) {
            this.name = map.name;
            this.mapResourceUUID = map.mapResourceUUID;
            this.width = map.width;
            this.height = map.height;
            this.legendPosition = map.legendPosition;
            for (const le of map.legendEntries) {
                this.legendEntries.push(new LegendEntry(le));
            }
            for (const s of map.stations) {
                this.stations.push(new Station(s));
            }
        }
    }
}
